import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Card, CARD_STATUS_MAP } from '../../interfaces/cards.interface';
import { CardsService } from '../../services/cards.service';
import { UsersService } from '../../services/users.service';


@Component({
  selector: 'app-card-preview',
  standalone: false,
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./card.component.scss']
})
export class CardPreviewComponent implements OnInit {
  @Input() card!: Card;
  @Input() active: boolean = true;

  cardStatusOptions = CARD_STATUS_MAP;
  cardForm!: FormGroup;
  loading = false;
  canDownloadPdf = false;

  constructor(
    private cardsService: CardsService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private usersService: UsersService
  ) {
    this.cardForm = this.fb.group({
      status: ['']
    });
  }

  ngOnInit() {
    this.usersService.getRole().subscribe({
      next: (role) => {
        this.canDownloadPdf = role === 'Admin' || role === 'Support';
      },
      error: () => {
        this.canDownloadPdf = false;
      }
    });
  }

  isEndless(): boolean {
    const e: any = this.card ? this.card.endless : null;
    return e === 1 || e === '1' || e === true;
  }

  getCardTypeLabel(person: any): string {
    if (!person) return '';
    
    const type = person.type;
    const parentId = person.parent_id;
    
    if (type === 'CHILDREN' && parentId && parentId > 0) {
      return 'Karta dziecka';
    } else if (type === 'CHILDREN') {
      return 'Karta rodzica';
    } else if (type === 'SENIOR') {
      return 'Karta seniora';
    } else if (type === 'CITIZEN') {
      return 'Karta mieszkańca';
    } else if (type === 'STUDENT') {
      return 'Karta studenta';
    }
    
    return type || '';
  }

}
